// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedSlitLampLeft_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.34141C14.3304 3.16508 16 5.38756 16 8C16 10.6124 14.3304 12.8349 12 13.6586V2.34141ZM4 8C4 10.6124 5.66962 12.8349 8 13.6586V2.34141C5.66962 3.16508 4 5.38756 4 8ZM2 8C2 12.4183 5.58172 16 10 16C14.4183 16 18 12.4183 18 8C18 3.58172 14.4183 0 10 0C5.58172 0 2 3.58172 2 8ZM18.3701 12.498L21.8301 18.4909L21.6792 18.5H19.5259L17.1051 14.307C17.5933 13.7573 18.0187 13.1506 18.3701 12.498ZM10 17.5006C9.90261 17.5006 9.80556 17.4991 9.70888 17.4962L12.5978 22.5H14.7511L14.902 22.4909L11.9099 17.3086C11.2929 17.4345 10.6542 17.5006 10 17.5006ZM19.8146 23H17.5052L13.8588 16.6842C14.4729 16.4109 15.0528 16.0743 15.5899 15.6827L19.8146 23Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedSlitLampLeft is a generated icon component.
 */
let IconMedSlitLampLeft = IconMedSlitLampLeft_1 = class IconMedSlitLampLeft extends IconBaseElement {
    render() {
        return html `${IconMedSlitLampLeft_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedSlitLampLeft.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedSlitLampLeft = IconMedSlitLampLeft_1 = __decorate([
    customElement('zui-icon-med-slit-lamp-left')
], IconMedSlitLampLeft);
export { IconMedSlitLampLeft };
